import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=5b4ea8b2&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=5b4ea8b2&prod&lang=scss&scoped=true"
import style1 from "./Settings.vue?vue&type=style&index=1&id=5b4ea8b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4ea8b2",
  null
  
)

export default component.exports